export default __webpack_public_path__ + "static/media/xRed.f1edff0c.svg";